import { useState } from 'react';
import { X } from 'lucide-react';
import type { CapturedIdea } from '../../lib/capturedIdeas';

interface Props {
  idea: CapturedIdea;
  onClose: () => void;
  onSave: (id: string, title: string, content: string) => Promise<void>;
}

export function EditIdeaModal({ idea, onClose, onSave }: Props) {
  const [title, setTitle] = useState(idea.title);
  const [content, setContent] = useState(idea.content);
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!title.trim() || !content.trim()) return;
    setSaving(true);
    try { await onSave(idea.id, title.trim(), content.trim()); onClose(); }
    finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl p-6 w-full max-w-lg">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-[#231F20]">Idee bewerken</h2>
          <button onClick={onClose} aria-label="Sluiten"><X className="w-5 h-5 text-gray-400" /></button>
        </div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Titel</label>
        <input value={title} onChange={e => setTitle(e.target.value)} maxLength={80}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4" />
        <label className="block text-sm font-medium text-gray-700 mb-1">Toelichting</label>
        <textarea value={content} onChange={e => setContent(e.target.value)} maxLength={300} rows={4}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4" />
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="btn-secondary">Annuleer</button>
          <button onClick={submit} disabled={saving || !title.trim() || !content.trim()} className="btn-primary">Opslaan</button>
        </div>
      </div>
    </div>
  );
}
